const APP_MODES = new Set(['editor', 'live', 'output', 'helper-download']);

export const resolveAppMode = (search = '') => {
  const params = new URLSearchParams(search || '');
  const mode = params.get('mode');
  return APP_MODES.has(mode) ? mode : 'editor';
};

export default resolveAppMode;
